import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { href: "#services", label: "Services" },
  { href: "#how", label: "How it works" },
  { href: "#honest", label: "Honest" },
  { href: "#proof", label: "Proof" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/85 border-b border-[#E4E4E7]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-24 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center group">
          <Logo height={80} />
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
              className="text-sm text-[#52525B] hover:text-[#09090B] transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+15106123656"
            data-testid="nav-phone"
            className="hidden lg:inline-flex items-center gap-2 text-sm font-medium text-[#09090B] hover:text-[#1F4DA0] transition-colors"
          >
            <Phone size={14} strokeWidth={2} />
            510-612-3656
          </a>
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex items-center bg-[#09090B] text-white font-bold px-4 py-2 text-sm hover:bg-[#1F4DA0] transition-colors"
          >
            Free LinkedIn audit →
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden w-9 h-9 grid place-items-center border border-[#09090B]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E4E4E7] bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                className="text-base font-medium text-[#09090B]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+15106123656"
              data-testid="mobile-phone"
              className="flex items-center gap-2 text-base font-medium text-[#1F4DA0]"
            >
              <Phone size={16} strokeWidth={2} />
              510-612-3656
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-button"
              className="bg-[#09090B] text-white font-bold px-4 py-3 text-sm text-center"
            >
              Free LinkedIn audit →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
